import './Field.css';

/**
 * Envoltorio de campo de formulario: etiqueta + ayuda + error, asociados por id.
 * Uso: <Field label="Nombre" htmlFor="nombre" hint="..." error="..."><Input id="nombre" /></Field>
 */
export default function Field({ label, htmlFor, hint, error, children }) {
  return (
    <div className="field">
      {label && <label className="field-label" htmlFor={htmlFor}>{label}</label>}
      {children}
      {hint && !error && <span className="field-hint">{hint}</span>}
      {error && <span className="field-error-text" role="alert">{error}</span>}
    </div>
  );
}